import { render, staticRenderFns } from "./FooterLogo.vue?vue&type=template&id=91504a1e&scoped=true&"
import script from "./FooterLogo.vue?vue&type=script&lang=js&"
export * from "./FooterLogo.vue?vue&type=script&lang=js&"
import style0 from "./FooterLogo.vue?vue&type=style&index=0&id=91504a1e&scoped=true&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "91504a1e",
  null
  
)

export default component.exports